var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title"},[_c('h2',{staticClass:"title",class:_vm.variant},[_vm._t("title")],2),_c('div',{staticClass:"actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }